<template>
  <div
    :class="[
      'flex flex-col gap-8 items-center max-w-5xl mx-auto py-8',
      reverse ? 'md:flex-row-reverse' : 'md:flex-row'
    ]"
  >
    <img
      :src="image"
      :alt="title"
      class="w-full h-48 sm:h-56 md:h-64 lg:h-72 xl:h-80 md:w-1/2 object-cover rounded-lg shadow-lg transition-all duration-300"
    />
    <div class="ai-card w-full md:flex-1 rounded-lg p-4 sm:p-6 md:p-8 shadow-lg flex flex-col justify-center items-center text-center">
      <h4 class="ai-title text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-2" style="font-family: 'Cormorant SC', serif;">
        {{ title }}
      </h4>
      <p class="ai-text mb-4 text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl">
        {{ description }}
      </p>
      <div class="ai-price text-base sm:text-lg md:text-xl lg:text-2xl font-semibold">
        {{ price }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlternatingImage",
  props: {
    image: String,
    title: String,
    description: String,
    price: String,
    reverse: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.ai-card {
  background: var(--surface);
  color: var(--on-surface);
  box-shadow: var(--card-shadow);
}

/* text colors from theme */
.ai-title { color: var(--primary); }
.ai-text  { color: var(--on-surface); }
.ai-price { color: var(--primary); }
</style>
